// extracted by mini-css-extract-plugin
export default {"editPenggunaSection":"style_editPenggunaSection__Q5Wi1","actionsSection":"style_actionsSection__5vVtT","formSection":"style_formSection__8e1kI"};